import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Route/UI guard: blocks child subaccounts from accessing parent-only pages
 * like payments, wallet history, and packages.
 */
export const normalizeStudentAccountType = (user) => {
  const explicitAccountType = String(user?.accountType || '').trim().toLowerCase();

  // The server has historically returned both accountType variants and some
  // child records only carry parentUserId. Treat either signal as authoritative
  // so a direct URL cannot bypass the same boundary enforced by the menu.
  if (explicitAccountType === 'child' || Boolean(user?.parentUserId)) {
    return 'child';
  }

  return explicitAccountType || 'parent';
};

const NonChildOnly = ({ children, redirectTo = '/Student-dashboard/dash' }) => {
  const { t } = useTranslation('global');
  const user = useSelector((state) => state.students.user);
  const authInitialized = useSelector((state) => state.students.authInitialized);

  const accountType = normalizeStudentAccountType(user);

  // Wait for auth bootstrap; some routes use this guard outside of ProtectedRoute.
  if (!authInitialized) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#F8FAFC',
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #E2E8F0',
          borderTop: '4px solid #113F67',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
        <p style={{
          marginTop: '16px',
          color: '#475569',
          fontSize: '16px',
          fontWeight: '500'
        }}>
          {t('protectedRoute.loading', 'Loading...')}
        </p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (accountType === 'child') {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};

export default NonChildOnly;
